export const LIFETIME_HYPOTHESES_CONFIG = {
  table: {
    className: "Verdikt-DynamicTable",
  },
  rangeSlider: {
    minMultiplier: 0.9,
    maxMultiplier: 1.1,
    defaultMin: 0,
    defaultMax: 10,
    defaultStep: 0.5,
    defaultDisplayStep: 1, // null means use step value
    marker: {
      width: "2px",
      height: "20px",
      top: "8px",
    },
  },
  colors: {
    actuals: "#000000", // black
    target: "#008060", // green
    market_average: "#007ace", // blue
  },
  styles: {
    legend: {
      fontSize: "12px",
      color: "#666",
      marginTop: "4px",
    },
    sliderContainer: {
      marginBottom: "8px",
      position: "relative",
      // Ensure the slider track is properly aligned
      paddingLeft: "0",
      paddingRight: "0",
    },
  },
  unit: {
    translationKeys: [
      "recommendation:propositions.levers.unit",
      "recommendation:propositions.levers.target_emissions.unit",
    ],
    fallback: "years",
  },
}
